import { gql } from '@apollo/client'

export const CLAIM_COLLECTABLES_MUTATION = gql`
  mutation claimChosenCollectibles($slug: String!) {
    createClaims(input: { projectSlug: $slug }) {
      profile {
        isChosenInvestor
        isChosenPiffer
        isChosenSubscriber
        isChosenInvestorSceneClaimed
        isChosenPifferSceneClaimed
        isChosenSubscriberSceneClaimed
      }
      claims {
        id
        guid
        created
        claimReason
      }
    }
  }
`

export interface ClaimResponse {
  profile?: {
    isChosenInvestor?: boolean
    isChosenPiffer?: boolean
    isChosenSubscriber?: boolean
    isChosenInvestorSceneClaimed?: boolean
    isChosenPifferSceneClaimed?: boolean
    isChosenSubscriberSceneClaimed?: boolean
  }
  claims?: {
    id?: string
    guid?: string
    claim_reason?: 'pif-one-time' | 'pif-subscriber' | 'investor'
  }[]
}
